import { render, staticRenderFns } from "./HolidaysChildrenPlansForm.vue?vue&type=template&id=4372cdca&"
import script from "./HolidaysChildrenPlansForm.vue?vue&type=script&lang=js&"
export * from "./HolidaysChildrenPlansForm.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysChildrenPlansForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports